import { ImageFit, ImageFormat, ImageSize } from './types.ts';

export const imageHelper = (
  imageId: string,
  format: ImageFormat = ImageFormat.webp,
  fit: ImageFit = ImageFit.cover,
  size: ImageSize = ImageSize.thumbnail,
): string => {
  const imageUrl: URL = new URL(`https://api.leicht.io/assets/${ imageId }`);

  imageUrl.searchParams.append('format', format);
  imageUrl.searchParams.append('fit', fit);

  switch (size) {
    case ImageSize.headerImage:
      imageUrl.searchParams.append('width', '1920');
      imageUrl.searchParams.append('height', '1080');
      break;
    case ImageSize.thumbnail:
      imageUrl.searchParams.append('width', '800');
      imageUrl.searchParams.append('height', '800');
      break;
    case ImageSize.slideshow:
      imageUrl.searchParams.append('width', '1200');
      imageUrl.searchParams.append('height', '1200');
      break;
  }

  imageUrl.searchParams.append('quality', '75');

  return imageUrl.toString();
};
